// Rashi + nakshatra catalogs for the Ashtakoot Milan Studio — data-only
// module split from the studio component at the G03 500-line ceiling.
// Classical reference vocabulary (varna, gana, nadi, yoni), never model
// prose; the koota arithmetic stays with the studio.

export interface RashiInfo {
  id: string;
  name: string;
  hindi: string;
  ruler: string;
  element: "Fire" | "Earth" | "Air" | "Water";
  varna: "Brahmin" | "Kshatriya" | "Vaishya" | "Shudra";
  vashya: "Chatushpada" | "Manava" | "Jalachara" | "Vanachara" | "Keeta";
}

export const RASHIS: RashiInfo[] = [
  {
    id: "mesha",
    name: "Aries (Mesha)",
    hindi: "मेष",
    ruler: "Mars",
    element: "Fire",
    varna: "Kshatriya",
    vashya: "Chatushpada",
  },
  {
    id: "vrishabha",
    name: "Taurus (Vrishabha)",
    hindi: "वृषभ",
    ruler: "Venus",
    element: "Earth",
    varna: "Vaishya",
    vashya: "Chatushpada",
  },
  {
    id: "mithuna",
    name: "Gemini (Mithuna)",
    hindi: "मिथुन",
    ruler: "Mercury",
    element: "Air",
    varna: "Shudra",
    vashya: "Manava",
  },
  {
    id: "karka",
    name: "Cancer (Karka)",
    hindi: "कर्क",
    ruler: "Moon",
    element: "Water",
    varna: "Brahmin",
    vashya: "Jalachara",
  },
  {
    id: "simha",
    name: "Leo (Simha)",
    hindi: "सिंह",
    ruler: "Sun",
    element: "Fire",
    varna: "Kshatriya",
    vashya: "Vanachara",
  },
  {
    id: "kanya",
    name: "Virgo (Kanya)",
    hindi: "कन्या",
    ruler: "Mercury",
    element: "Earth",
    varna: "Vaishya",
    vashya: "Manava",
  },
  {
    id: "tula",
    name: "Libra (Tula)",
    hindi: "तुला",
    ruler: "Venus",
    element: "Air",
    varna: "Shudra",
    vashya: "Manava",
  },
  {
    id: "vrishchika",
    name: "Scorpio (Vrishchika)",
    hindi: "वृश्चिक",
    ruler: "Mars",
    element: "Water",
    varna: "Brahmin",
    vashya: "Keeta",
  },
  {
    id: "dhanu",
    name: "Sagittarius (Dhanu)",
    hindi: "धनु",
    ruler: "Jupiter",
    element: "Fire",
    varna: "Kshatriya",
    vashya: "Manava",
  },
  {
    id: "makara",
    name: "Capricorn (Makara)",
    hindi: "मकर",
    ruler: "Saturn",
    element: "Earth",
    varna: "Vaishya",
    vashya: "Jalachara",
  },
  {
    id: "kumbha",
    name: "Aquarius (Kumbha)",
    hindi: "कुंभ",
    ruler: "Saturn",
    element: "Air",
    varna: "Shudra",
    vashya: "Manava",
  },
  {
    id: "meena",
    name: "Pisces (Meena)",
    hindi: "मीन",
    ruler: "Jupiter",
    element: "Water",
    varna: "Brahmin",
    vashya: "Jalachara",
  },
];

export const NAKSHATRAS = [
  { name: "Ashwini", gana: "Deva", nadi: "Aadi", yoni: "Horse" },
  { name: "Bharani", gana: "Manushya", nadi: "Madhya", yoni: "Elephant" },
  { name: "Krittika", gana: "Rakshasa", nadi: "Antya", yoni: "Sheep" },
  { name: "Rohini", gana: "Manushya", nadi: "Antya", yoni: "Serpent" },
  { name: "Mrigashira", gana: "Deva", nadi: "Madhya", yoni: "Serpent" },
  { name: "Ardra", gana: "Manushya", nadi: "Aadi", yoni: "Dog" },
  { name: "Punarvasu", gana: "Deva", nadi: "Aadi", yoni: "Cat" },
  { name: "Pushya", gana: "Deva", nadi: "Madhya", yoni: "Goat" },
  { name: "Ashlesha", gana: "Rakshasa", nadi: "Antya", yoni: "Cat" },
  { name: "Magha", gana: "Rakshasa", nadi: "Antya", yoni: "Rat" },
  { name: "Purva Phalguni", gana: "Manushya", nadi: "Madhya", yoni: "Rat" },
  { name: "Uttara Phalguni", gana: "Manushya", nadi: "Aadi", yoni: "Cow" },
  { name: "Hasta", gana: "Deva", nadi: "Aadi", yoni: "Buffalo" },
  { name: "Chitra", gana: "Rakshasa", nadi: "Madhya", yoni: "Tiger" },
  { name: "Swati", gana: "Deva", nadi: "Antya", yoni: "Buffalo" },
  { name: "Vishakha", gana: "Rakshasa", nadi: "Antya", yoni: "Tiger" },
  { name: "Anuradha", gana: "Deva", nadi: "Madhya", yoni: "Deer" },
  { name: "Jyeshtha", gana: "Rakshasa", nadi: "Aadi", yoni: "Deer" },
  { name: "Moola", gana: "Rakshasa", nadi: "Aadi", yoni: "Dog" },
  { name: "Purva Ashadha", gana: "Manushya", nadi: "Madhya", yoni: "Monkey" },
  { name: "Uttara Ashadha", gana: "Manushya", nadi: "Antya", yoni: "Mongoose" },
  { name: "Shravana", gana: "Deva", nadi: "Antya", yoni: "Monkey" },
  { name: "Dhanishta", gana: "Rakshasa", nadi: "Madhya", yoni: "Lion" },
  { name: "Shatabhisha", gana: "Rakshasa", nadi: "Aadi", yoni: "Horse" },
  { name: "Purva Bhadrapada", gana: "Manushya", nadi: "Aadi", yoni: "Lion" },
  { name: "Uttara Bhadrapada", gana: "Manushya", nadi: "Madhya", yoni: "Cow" },
  { name: "Revati", gana: "Deva", nadi: "Antya", yoni: "Elephant" },
];
